"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notationPositionType = exports.default = exports.Input = exports.AcceptType = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
require("./standardInput.css");
var _VerticalStack = _interopRequireDefault(require("../VerticalStack/index.js"));
var _HorizontalStack = _interopRequireDefault(require("../HorizontalStack/index.js"));
var _Typography = _interopRequireWildcard(require("../Typography/index.js"));
var _InputVStack = require("./components/InputVStack.js");
var _InputComponent = require("./components/InputComponent.js");
var _InputSubVStack = require("./components/InputSubVStack.js");
var _onKeyPressValidatiion = require("../../../utils/onKeyPressValidatiion.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _SvgIcon = _interopRequireDefault(require("../SvgIcon/index.js"));
var _images = require("../../../assets/images.js");
var _PlaceholderLabel = require("./components/PlaceholderLabel.js");
var _NotationComponent = _interopRequireDefault(require("./components/NotationComponent.js"));
var _constant = require("./constant.js");
var _Tooltip = require("../Tooltip/index.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["placeholder", "type", "accept", "name", "value", "width", "bg", "defaultTextColor", "secondaryTextColor", "defaultBorderColor", "disablebgColor", "hoverColor", "focusColor", "errorColor", "successColor", "disabled", "error", "success", "rightElement", "helperText", "onTextChange", "onTextEventChange", "onSelectionOption", "onBlur", "onFieldClick", "minNumValue", "maxNumValue", "valueTextAlign", "helperTextClassName", "className", "fieldKey", "textIcon", "textIconHeight", "textIconWidth", "spacingIcon", "leftIcon", "leftIconHoverColor", "onClickIcon", "required", "autoFocus", "inputRef", "inputVerticalStyle", "hideLabelOnInput", "variant", "maxLength", "showChevron", "notationPosition", "isFloatingLabel", "requiredStarColor", "placeHolderVariant", "maxCharacterAllowed", "isSearchDataAllowed", "filteredOptionsData", "deltaIcon", "onClickLeftIcon", "onKeyPress", "onFocusAction", "id", "isVirtualKeyboard", "searcUrlRequired", "placeholderTextColor", "helperTextColor", "requiredTextColor", "focusStateBorderColor", "errorStateBorderColor", "successStateBorderColor", "disabledStateBorderColor", "borderWidth", "borderStyle", "borderRadius", "padding", "margin", "leftIconFillColor", "leftIconFillHoverColor", "boxShadow", "textFontSize", "textFontFamily", "textFontStyle", "textTransformation", "textFontWeight", "wordSpacing", "textIndent", "textPadding", "textMargin", "textDecoration", "letterSpacing", "lineHeight", "textShadow", "placeholderFontFamily", "placeholderFontStyle", "placeholderFontWeight", "placeholderFontSize", "placeholderTextTransform", "placeholderTextDecoration", "isSaveIconEnabled", "placeholderLineHeight", "handleSaveIcon", "handleTypingState", "handleFieldFocusStatus", "initialValue", "placeHolderColor", "paddingHorizontal", "paddingVertical"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let AcceptType = exports.AcceptType = /*#__PURE__*/function (AcceptType) {
  AcceptType["text"] = "text";
  AcceptType["number"] = "number";
  AcceptType["all"] = "all";
  AcceptType["decimal"] = "decimal";
  AcceptType["password"] = "password";
  return AcceptType;
}({});
let notationPositionType = exports.notationPositionType = /*#__PURE__*/function (notationPositionType) {
  notationPositionType["right"] = "right";
  notationPositionType["left"] = "left";
  return notationPositionType;
}({});
const Input = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      placeholder,
      type = 'text',
      accept = AcceptType.all,
      name,
      value = '',
      width = '100%',
      bg = theme.color.primaryBgColor,
      defaultTextColor = theme.color.defaultTextColor,
      secondaryTextColor = theme.color.defaultTextColor,
      defaultBorderColor = theme.color.defaultBorderColor,
      disablebgColor = theme.color.disabledBgColor,
      hoverColor = theme.color.primary,
      focusColor = theme.color.primary,
      errorColor = theme.color.error,
      successColor = theme.color.success,
      disabled = false,
      error = false,
      success = false,
      rightElement,
      helperText,
      onTextChange,
      onTextEventChange,
      onSelectionOption,
      onBlur,
      onFieldClick,
      minNumValue,
      maxNumValue,
      valueTextAlign,
      helperTextClassName,
      className,
      fieldKey,
      textIcon,
      textIconHeight = '28px',
      textIconWidth = '28px',
      spacingIcon = "16px",
      leftIcon,
      leftIconHoverColor,
      onClickIcon,
      required,
      autoFocus,
      inputRef,
      inputVerticalStyle,
      hideLabelOnInput,
      variant,
      maxLength,
      showChevron = false,
      notationPosition = notationPositionType.right,
      isFloatingLabel = false,
      requiredStarColor = theme.color.error,
      placeHolderVariant = _Typography.typographyVariantEnum.body,
      maxCharacterAllowed = 255,
      isSearchDataAllowed,
      filteredOptionsData,
      deltaIcon = false,
      // decimal,
      onClickLeftIcon,
      onKeyPress,
      onFocusAction,
      id,
      isVirtualKeyboard = false,
      searcUrlRequired = false,
      placeholderTextColor = theme.color.defaultTextColor,
      helperTextColor = theme.color.defaultTextColor,
      requiredTextColor = theme.color.error,
      focusStateBorderColor = theme.color.primary,
      errorStateBorderColor = theme.color.error,
      successStateBorderColor = theme.color.success,
      disabledStateBorderColor = ' #dedede',
      borderWidth = 1,
      borderStyle = 'solid',
      borderRadius = theme.variables.borderRadius,
      padding,
      margin,
      leftIconFillColor = theme.color.neutral300,
      leftIconFillHoverColor = theme.color.primary200,
      boxShadow,
      textFontSize,
      textFontFamily,
      textFontStyle,
      textTransformation,
      textFontWeight,
      wordSpacing,
      textIndent,
      textPadding,
      textMargin,
      textDecoration,
      letterSpacing,
      lineHeight,
      textShadow,
      placeholderFontFamily,
      placeholderFontStyle,
      placeholderFontWeight = 400,
      placeholderFontSize = 12,
      placeholderTextTransform,
      placeholderTextDecoration,
      isSaveIconEnabled = false,
      placeholderLineHeight = '15px',
      handleSaveIcon,
      handleTypingState,
      handleFieldFocusStatus,
      initialValue,
      placeHolderColor,
      paddingHorizontal,
      paddingVertical
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const [isHover, setHover] = (0, _react.useState)(false);
  const [isFocus, setFocus] = (0, _react.useState)(false);
  const [activeFocusText, setActiveFocusText] = (0, _react.useState)(0);
  const [filteredOptions, setFilteredOptions] = (0, _react.useState)([]);
  const [activeFilteredData, setActiveFilteredData] = (0, _react.useState)([]);
  const [val, setValue] = (0, _react.useState)(value);
  const [showFilterData, setshowFilterData] = (0, _react.useState)(activeFilteredData?.length > 0);
  const inputReferance = _react.default.useRef(inputRef);
  (0, _react.useEffect)(() => {
    setFilteredOptions(filteredOptionsData ?? []);
  }, [filteredOptionsData]);
  (0, _react.useEffect)(() => {
    setValue(value);
  }, [value]);
  (0, _react.useEffect)(() => {
    val?.length > 0 && setshowFilterData(activeFilteredData?.length > 0);
  }, [activeFilteredData, val]);
  const standardInputStyle = ['standardinput__', className].join(' ');
  const helperTextStyle = ['standardinput__helpertext-style', helperTextClassName].join(' ');
  const onMouseEnter = () => {
    if (!disabled) {
      setHover(true);
    }
  };
  const onMouseSelectonEnter = () => {
    if (!disabled) {
      setFocus(true);
    }
  };
  const onMouseSelectonLeave = () => {
    if (!disabled) {
      setFocus(false);
      setActiveFocusText(0);
    }
  };
  const onMouseLeave = () => {
    if (!disabled && !showFilterData) {
      setHover(false);
    }
  };
  const onClick = () => {
    if (!disabled) {
      setFocus(true);
      inputReferance.current?.focus();
      onFieldClick?.();
    }
  };
  const onClickLeft = () => {
    if (!disabled) {
      if (onClickLeftIcon) {
        onClickLeftIcon?.();
      } else {
        onClickIcon?.();
      }
    }
  };
  const onFocus = () => {
    if (!disabled) {
      setFocus(true);
      onFocusAction?.();
      inputReferance.current?.focus();
      handleFieldFocusStatus && handleFieldFocusStatus(true);
    }
  };
  const onBlurInput = value => {
    onBlur && onBlur(value);
    !showFilterData && setFocus(false);
    numberValueMinMaxValidation();
    if (value === "" || value === initialValue) {
      setValue("");
      handleTypingState && handleTypingState(false);
    }
  };
  const handleKeyPress = event => {
    if (onKeyPress) {
      onKeyPress(event);
    } else {
      (0, _onKeyPressValidatiion.onKeyPressField)(event, accept);
    }
  };
  const onNumberIncrease = () => {
    let numberValue = (parseInt(val) || 0) + 1;
    if (maxNumValue) {
      if (numberValue > maxNumValue) numberValue = maxNumValue;
    }
    onNumberChange(numberValue);
  };
  const onNumberDecrease = () => {
    let numberValue = (parseInt(val) || 0) - 1;
    if (minNumValue) {
      if (numberValue < minNumValue) numberValue = minNumValue;
    }
    onNumberChange(numberValue);
  };
  const numberValueMinMaxValidation = () => {
    if (type !== 'number') return;
    const numValue = parseInt(value);
    if (minNumValue || minNumValue == 0) {
      if (numValue < minNumValue) {
        const minVal = minNumValue.toString();
        setValue(minVal);
        if (onTextChange) {
          onTextChange(minVal);
        }
        return;
      }
    }
    if (maxNumValue) {
      if (numValue > maxNumValue) {
        const maxVal = maxNumValue.toString();
        setValue(maxVal);
        if (onTextChange) {
          onTextChange(maxVal);
        }
        return;
      }
    }
  };
  const validateDecimal = num => {
    // Check if the input is a valid number
    if (isNaN(num)) {
      return false;
    }
    // Check if the input has more than one decimal point
    if ((num.match(/\./g) || [])?.length > 1) {
      return false;
    }
    // Remove any extra decimal points
    num = num.replace(/(\.\d+)\./g, '$1');
    return num;
  };
  const onNumberChange = value => {
    const val = isNaN(value) ? '' : value.toString();
    setValue(val);
    if (onTextChange) {
      onTextChange(val);
    }
  };
  const onChange = target => {
    if (maxCharacterAllowed && target.currentTarget.value?.length > maxCharacterAllowed) return;
    const inputValue = target.currentTarget.value;
    if (type == AcceptType.number) {
      setValue(target.currentTarget.value);
      if (inputValue !== initialValue && inputValue !== "") {
        handleTypingState && handleTypingState(true);
      }
      if (onTextChange) {
        onTextChange(target.currentTarget.value);
      }
      return;
    }
    if (type == AcceptType.text) {
      setValue(target.currentTarget.value);
      if (inputValue !== initialValue && inputValue !== "") {
        handleTypingState && handleTypingState(true);
      }
      if (onTextChange) {
        onTextChange(target.currentTarget.value);
      }
      if (onTextEventChange) {
        onTextEventChange(target);
      }
    }
    if (type == AcceptType.password) {
      setValue(target.currentTarget.value);
      if (inputValue !== initialValue && inputValue !== "") {
        handleTypingState && handleTypingState(true);
      }
      if (onTextChange) {
        onTextChange(target.currentTarget.value);
      }
    }
    if (type == AcceptType.decimal) {
      const validatedNumber = validateDecimal(target.currentTarget.value);
      if (validatedNumber) {
        setValue(validatedNumber);
        if (inputValue !== initialValue && inputValue !== "") {
          handleTypingState && handleTypingState(true);
        }
        if (onTextChange) {
          onTextChange(validatedNumber);
        }
        return;
      }
    }
    if (isSearchDataAllowed) {
      const filtered = filteredOptions.filter(option => {
        // Check if content is a string before calling .toLowerCase()
        const content = typeof option?.content === 'string' || typeof option?.content === 'number' ? `${option.content}`.toLowerCase() : '';

        // Check if the input value is a string before calling .toLowerCase()
        const searchValue = typeof target?.currentTarget?.value === 'string' || typeof target?.currentTarget?.value === 'number' ? `${target?.currentTarget?.value}`.toLowerCase() : '';
        return content.includes(searchValue);
      });
      setActiveFilteredData(filtered);
    }
  };
  const standardInputVerticalStackStyle = `standardinput__vertical-style ${inputVerticalStyle}`;
  const onSelectionText = value => {
    onTextChange?.(value?.content);
    onSelectionOption?.(value);
    setActiveFocusText(0);
    setshowFilterData(false);
  };
  const onFilterOptionMouseEnter = index => {
    setActiveFocusText(index + 1);
  };
  const onFilterOptionMouseLeave = index => {
    setActiveFocusText(index + 1);
  };
  let showNotation = false;
  if (showChevron == true || deltaIcon == true) {
    showNotation = true;
  }

  // const decimalVal: string = decimal && type === AcceptType.number ? limitDecimalPrecision(val, decimal) : val;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_VerticalStack.default, {
    width: width,
    style: {
      opacity: disabled ? '0.4' : '1',
      padding: padding,
      margin: margin,
      display: 'flex'
    },
    className: standardInputVerticalStackStyle,
    disabled: disabled,
    disablebgColor: disablebgColor,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputVStack.InputVStack, {
      error: error,
      success: success,
      errorColor: errorColor,
      successColor: successColor,
      disabled: disabled,
      isFocus: isFocus,
      focusColor: focusColor,
      isHover: isHover,
      hoverColor: hoverColor,
      defaultBorderColor: defaultBorderColor,
      defaultTextColor: defaultTextColor,
      onBlur: onBlur,
      width: width,
      val: val,
      height: (hideLabelOnInput || isFloatingLabel) && placeholder ? 'auto' : '32px',
      bg: bg,
      borderRadius: borderRadius,
      className: standardInputStyle,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onFocus: onFocus,
      disablebgColor: disablebgColor,
      focusStateBorderColor: focusStateBorderColor,
      errorStateBorderColor: errorStateBorderColor,
      successStateBorderColor: successStateBorderColor,
      disabledStateBorderColor: disabledStateBorderColor,
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      boxShadow: boxShadow,
      textPadding: textPadding,
      textMargin: textMargin,
      paddingHorizontal: paddingHorizontal,
      paddingVertical: paddingVertical,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_HorizontalStack.default, {
        spacing: `${spacingIcon}`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_HorizontalStack.default, {
          spacing: "16px",
          className: "input-number-container",
          children: [type == 'number' && showNotation && notationPosition == 'left' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "number-input-chevron__container",
            children: (0, _NotationComponent.default)(onNumberIncrease, isHover, onNumberDecrease, deltaIcon)
          }), leftIcon && (searcUrlRequired ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _constant.LeftIconurl,
            className: "standardinput__lefticon-style",
            onClick: !disabled ? onClickLeft : () => {}
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon.default, {
            url: leftIcon,
            className: "standardinput__lefticon-style",
            onClick: !disabled ? onClickLeft : () => {},
            fillColor: leftIconFillColor,
            fillHoverColor: leftIconFillHoverColor,
            strokeHoverColor: leftIconHoverColor,
            strokeColor: theme.color.defaultTextColor,
            isHover: isHover || isFocus
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputSubVStack.InputSubVStack, {
            onClick: onClick,
            className: inputVerticalStyle,
            children: [!hideLabelOnInput && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PlaceholderLabel.PlaceholderLabel, {
              className: "floating-placeholder",
              theme: theme,
              as: "span",
              color: placeholderTextColor ? placeholderTextColor : isFocus ? theme.color.black : secondaryTextColor,
              variant: placeHolderVariant ?? 'body-small'
              // style={{ lineHeight: placeholderLineHeight }}
              ,
              isFloatingLabel: isFloatingLabel,
              isLabelFloating: isFocus || val?.length > 0,
              fontFamily: placeholderFontFamily,
              fontStyle: placeholderFontStyle,
              fontSize: `${placeholderFontSize}px`,
              fontWeight: `${placeholderFontWeight}`,
              textTransformation: placeholderTextTransform,
              textDecoration: placeholderTextDecoration,
              placeholderLineHeight: placeholderLineHeight,
              children: [placeholder, required ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputSubVStack.RequiredSpan, {
                requiredStarColor: requiredStarColor,
                children: "*"
              }) : '']
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputComponent.InputComponent, Object.assign({
              error: error,
              success: success,
              errorColor: errorColor,
              id: id,
              successColor: successColor,
              defaultTextColor: defaultTextColor,
              isFocus: isFocus,
              val: val,
              autoFocus: autoFocus,
              value: val,
              ref: inputReferance,
              valueTextAlign: valueTextAlign,
              onChange: onChange,
              disabled: disabled,
              onBlur: onBlurInput,
              onKeyPress: handleKeyPress,
              type: type,
              name: name,
              required: required,
              placeholder: hideLabelOnInput ? placeholder : '',
              variant: variant,
              maxLength: maxLength,
              disablebgColor: disablebgColor,
              min: minNumValue,
              max: maxNumValue,
              fontSize: `${textFontSize}px`,
              textFontFamily: textFontFamily,
              textFontStyle: textFontStyle,
              textTransformation: textTransformation,
              textFontWeight: textFontWeight,
              wordSpacing: wordSpacing,
              textDecoration: textDecoration,
              letterSpacing: letterSpacing,
              lineHeight: lineHeight,
              textShadow: textShadow,
              textIndent: textIndent,
              placeHolderColor: placeHolderColor ? placeHolderColor : placeholderTextColor,
              placeholderFontFamily: placeholderFontFamily,
              placeholderFontStyle: placeholderFontStyle,
              placeholderFontSize: placeholderFontSize,
              placeholderFontWeight: placeholderFontWeight,
              placeholderTextTransform: placeholderTextTransform,
              placeholderTextDecoration: placeholderTextDecoration,
              placeholderLineHeight: placeholderLineHeight
            }, rest), fieldKey + 'text-field')]
          }), type == 'number' && showNotation && notationPosition == 'right' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "number-input-chevron__container",
            children: (0, _NotationComponent.default)(onNumberIncrease, isHover, onNumberDecrease, deltaIcon)
          })]
        }), textIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: "text-input-right-icon",
          src: textIcon,
          height: textIconHeight,
          width: textIconWidth,
          onClick: onClickIcon
        }), rightElement !== undefined && rightElement, isSaveIconEnabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
          className: "placeholder-save-tooltip",
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: _Typography.typographyVariantEnum.labelSemiBold,
            children: "Click to save"
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _images.saveRightIcon,
            className: "placeholder-svg-right-icon",
            onClick: handleSaveIcon
          })
        })]
      })
    }), isSearchDataAllowed && showFilterData && isFocus && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputVStack.InputOptionsVStack, {
      className: "search-options",
      backgroundColor: theme.color.primaryBgColor,
      onMouseEnter: onMouseSelectonEnter,
      onMouseLeave: onMouseSelectonLeave,
      onFocus: onFocus,
      children: activeFilteredData.map((option, index) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputVStack.InputOptionsValueVStack, {
          onClick: () => onSelectionText?.(option),
          backgroundColor: activeFocusText == index + 1 ? theme.color.secondary200 : '',
          onMouseEnter: () => onFilterOptionMouseEnter(index),
          onMouseLeave: () => onFilterOptionMouseLeave(index),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: _Typography.typographyVariantEnum.caption,
            children: option.content
          })
        }, index);
      })
    }), helperText !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      className: helperTextStyle,
      as: "p",
      color: required ? requiredTextColor : error ? errorColor : success ? successColor : helperTextColor,
      variant: "caption",
      children: helperText
    })]
  });
};
exports.Input = Input;
var _default = exports.default = Input;